import { cn } from '../../lib/helpers.ts';
import { Dimension, DIMENSION_LABELS } from '../../lib/plan/types';

interface DimensionFeedbackProps {
    dimension: Dimension;
    score: number;
    isPrimary?: boolean;
}

// Texty jsou návrh Clauda k doladění odborníkem (psycholog).
// Tón: měkký, nehodnotící — rámováno jako prostor pro růst, ne jako nedostatek.
const FEEDBACK_TEXTS: Record<Dimension, { low: string; mid: string; high: string }> = {
    koncentrace: {
        low: 'Soustředění je teď oblast, kde má vaše třída největší prostor růst. Krátká zklidňující cvičení před prací pomohou dětem snáz se naladit.',
        mid: 'Třída se dokáže soustředit, i když to občas vyžaduje vaši podporu. Pravidelné krátké rituály na začátku hodiny to dál posílí.',
        high: 'Soustředění patří mezi silné stránky vaší třídy. Stačí ho udržovat drobnými rituály, které děti už znají.',
    },
    atmosfera: {
        low: 'Atmosféra ve třídě má teď prostor se uvolnit — děti mohou být citlivější na napětí a hodnocení. Cvičení na bezpečí a klid jim pomohou.',
        mid: 'Atmosféra ve třídě je většinou v pohodě, i když občas zakolísá. Pravidelná relaxační cvičení ji udrží stabilní.',
        high: 'Atmosféra ve třídě je jednou ze silných stránek — děti se v ní cítí bezpečně i v náročnějších chvílích.',
    },
    vztahy: {
        low: 'Vztahy mezi dětmi jsou teď oblastí, kde má třída největší prostor růst. Cvičení na spolupráci a vzájemné ocenění pomohou kolektivu držet víc pohromadě.',
        mid: 'Vztahy ve třídě fungují, i když občas vznikne drobné pnutí. Pravidelná cvičení na spolupráci je dál posílí.',
        high: 'Vztahy ve třídě jsou silnou stránkou — děti si přirozeně pomáhají a drží spolu.',
    },
    emoce: {
        low: 'Práce s emocemi je teď oblast, kde má vaše třída největší prostor růst. Cvičení na pojmenování a zvládání emocí dětem pomohou lépe rozumět tomu, co prožívají.',
        mid: 'Děti se s emocemi vypořádávají docela dobře, i když jim občas chybí slova nebo klid. Pravidelná cvičení to dál podpoří.',
        high: 'Práce s emocemi je silnou stránkou vaší třídy — děti dokážou své pocity pojmenovat i přijmout.',
    },
};

function getBand(score: number): 'low' | 'mid' | 'high' {
    if (score < 2) return 'low';
    if (score < 3) return 'mid';
    return 'high';
}

export function DimensionFeedback({
    dimension,
    score,
    isPrimary = false,
}: DimensionFeedbackProps) {
    const percentage = Math.round((score / 4) * 100);
    const text = FEEDBACK_TEXTS[dimension][getBand(score)];

    return (
        <div
            className={cn(
                'rounded-xl px-4 py-3',
                isPrimary ? 'bg-orange-100' : 'bg-cloud-100'
            )}
        >
            <p
                className={cn(
                    'text-sm font-semibold',
                    isPrimary ? 'text-orange-600' : 'text-ink-800'
                )}
            >
                {DIMENSION_LABELS[dimension]} · {percentage} %
            </p>
            <p
                className={cn(
                    'text-sm',
                    isPrimary ? 'text-orange-700' : 'text-ink-700'
                )}
            >
                {text}
            </p>
        </div>
    );
}
